module.exports = __webpack_public_path__ + "static/actualite-bef1c76bbdbdb4d93b1ea76e2c9fcbce.png";